/*=========================================================================================
  File Name: main.js
  Description: main vue(js) file
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/


import Vue from 'vue';
import './plugins';
import App from './app/app.vue';

// Vuesax Component Framework
import Vuesax from 'vuesax'
import 'material-icons/iconfont/material-icons.css' //Material Icons
import 'vuesax/dist/vuesax.css'; // Vuesax
Vue.use(Vuesax)

// App Configurations
import '../appConfig.js'

// Theme Configurations
import '../themeConfig.js'


// ACL
import acl from './app/shared/acl/acl'


// Globally Registered Components
import './app/shared/globalComponents.js'


// Styles: SCSS
import './assets/scss/main.scss'


// Tailwind
import '@/assets/css/main.css';


// i18n
import i18n from './i18n/i18n'


// Vuesax Admin Filters
import './app/shared/filters/filters'


// Clipboard
import VueClipboard from 'vue-clipboard2'
Vue.use(VueClipboard);


// Tour
import VueTour from 'vue-tour'
Vue.use(VueTour)
require('vue-tour/dist/vue-tour.css')


// VeeValidate
import VeeValidate from 'vee-validate';
Vue.use(VeeValidate);


// Google Maps
import * as VueGoogleMaps from 'vue2-google-maps'
Vue.use(VueGoogleMaps, {
    load: {
        // Add your API key here
        key: 'YOUR_API_KEY',
        libraries: 'places', // This is required if you use the Auto complete plug-in
    },
})

// Vuejs - Vue wrapper for hammerjs
import { VueHammer } from 'vue2-hammer'
Vue.use(VueHammer)


// PrismJS
import 'prismjs'
import 'prismjs/themes/prism-tomorrow.css'


// Feather font icon
require('./assets/css/iconfont.css')

// Vuejs - Vue wait - Multiple Process Loader Management
import VueWait from 'vue-wait'
Vue.use(VueWait)

// A lightweight progress bar for vue
import VueProgressBar from 'vue-progressbar'
const VueProgressBarOptions = {
  color: '#bffaf3',
  failedColor: '#874b4b',
  thickness: '5px',
  transition: {
    speed: '0.2s',
    opacity: '0.6s',
    termination: 300
  },
  autoRevert: true,
  location: 'left',
  inverse: false
};
Vue.use(VueProgressBar, VueProgressBarOptions)

// A scroll loading component for vue.js.
import ScrollLoader from 'vue-scroll-loader'
Vue.use(ScrollLoader)

// A tiny javascript library to help printing from the web.
import print from 'print-js'
// Vue.use(print)

// Handy Moment.js filters for your Vue.js project.
Vue.use(require('vue-moment'));

// A simple to use directive for debounce solutions
import vueDebounce from 'vue-debounce' 
Vue.use(vueDebounce);

import VueFriendlyIframe from 'vue-friendly-iframe';
Vue.use(VueFriendlyIframe);

import FileUpload from 'vue-upload-component'
Vue.use(FileUpload);

// Import FilePond
import vueFilePond from 'vue-filepond';

// import Vidle from 'v-idle'
// Vue.use(Vidle)

import router from './app/app-routes';
import store from './app/app-state';

Vue.config.productionTip = false;
// Vue.config.performance = true;

new Vue({
    router,
    store,
    i18n,
    acl,
    wait: new VueWait({
      useVuex: true, // You must pass this option `true` to use Vuex
      vuexModuleName: 'wait' // It's optional, `wait` by default.
    }),
    render: h => h(App)
}).$mount('#app');
